export enum ContentTypeEnum {
  pdf = 0,
  csv = 1,
  excel = 2,
}
